<template>
  <section class="freight">
    <vue-final-modal v-model="showDimensionModal" name="dimension-modal">
      <div
        style="height: 100vh; padding: 0; margin: 0; display: flex; align-items: center; justify-content: center;"
      >
        <div style="width: auto;">
          <div style="background-color: #fff; padding: 20px;">
            <div class="form-row">
              <div class="form-group">
                <label>Length</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="dimension.length"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">m</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Width</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="dimension.width"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">m</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Height</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="dimension.height"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">m</span>
                  </div>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-success btn-small"
              @click="this.setVolume"
            >
              Set Volume
            </button>
            <button
              type="button"
              class="btn btn-primary btn-small"
              @click="this.closeModalDimension"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <div
      class="freight-content outlined rounded-lg p-4 mb-4 bg-white"
      style="border-color: #6b7280"
    >
      <h2 class="h5 mb-4">Freight</h2>

      <div v-if="loading" class="text-center mb-4">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else v-for="(line, index) in freight" :key="index">
        <div class="form-row freight-row">
          <div class="form-group col-sm-4 col-lg-2">
            <label v-if="index === 0">Number</label>
            <select
              class="form-control"
              v-model="line.quantity"
              :class="{ 'is-invalid': errors.has('quantity-' + index) }"
              :name="'quantity-' + index"
              v-validate="'required'"
              @change="computedAll($event, index, true)"
            >
              <option v-for="number in (1, 50)" :key="number">
                {{ number }}
              </option>
            </select>
            <div
              v-show="errors.has('quantity-' + index)"
              class="invalid-feedback"
            >
              Please select a quantity
            </div>
          </div>
          <div
            class="form-group"
            :class="
              hasChepAccess == 1 && line.packageType === 1
                ? 'col-sm-10 col-lg-5'
                : 'col-sm-12 col-lg-6'
            "
          >
            <label v-if="index === 0"
              >Type
              <small style="font-weight: bold"
                ><a
                  target="_blank #test"
                  :href="'/settings/account#filters'"
                  tabindex="-1"
                >
                  (edit)</a
                ></small
              ></label
            >
            <select
              class="form-control"
              v-model="line.packageType"
              :class="{ 'is-invalid': errors.has('package_type_id-' + index) }"
              :name="'package_type_id-' + index"
              v-validate="'required'"
              @change="
                onChangeType(
                  $event,
                  index,
                  packageTypes,
                  line.other_desc.default
                )
              "
            >
              <option
                v-for="packageType in packageTypes"
                :value="packageType.id"
                :key="packageType.id"
              >
                {{ packageType.name }}
              </option>
            </select>
            <input
              type="text"
              class="form-control"
              v-model="line.max_weight"
              :name="'max_weight-' + index"
              style="display: none"
            />
            <input
              type="text"
              class="form-control"
              v-model="line.max_volume"
              :name="'max_volume-' + index"
              style="display: none"
            />
            <div
              v-show="errors.has('package_type_id-' + index)"
              class="invalid-feedback"
            >
              Please select the type of package
            </div>
          </div>
          <div
            v-show="hasChepAccess == 1 && line.packageType === 1"
            class="form-group checkbox col-sm-2 col-lg-1"
          >
            <label v-if="index === 0">Chep</label>

            <a-popover visible-arrow="true" trigger="hover" placement="bottom">
              <template slot="content">
                <div style="max-width: 200px">
                  Freighthub makes transferring/swapping your CHEP pallets easy.
                  <br />
                  Please tick this box if your freight is on a CHEP pallet
                  <b> AND </b>you want it swapped. <br />
                  <b>DO NOT </b>tick the box if you are transferring a CHEP
                  pallet to your customer's account (such as Foodstuffs or
                  Progressive DC).<br />
                  We keep a tally of CHEP pallets owed and deliver more when
                  needed!
                </div>
              </template>
              <div style="padding-top: 6px; padding-left: 10px">
                <input
                  class="checkbox"
                  type="checkbox"
                  placeholder="Chep"
                  v-model="line.chep"
                  :class="{ 'is-invalid': errors.has('chep-' + index) }"
                  :name="'chep-' + index"
                />
              </div>
            </a-popover>
          </div>
          <div class="form-group col-sm-8 col-lg-5">
            <label v-if="index === 0">Contains </label>
            <select
              class="form-control"
              v-model.number="line.goodsType"
              @change="checkIfDangerous(line)"
              :class="{ 'is-invalid': errors.has('goods_type_id-' + index) }"
              :name="'goods_type_id-' + index"
              v-validate="'required'"
            >
              <option
                v-for="goodType in goodTypes"
                :value="goodType.id"
                :key="goodType.id"
              >
                {{ goodType.name }}
              </option>
            </select>
            <div
              v-show="errors.has('goods_type_id-' + index)"
              class="invalid-feedback"
            >
              Please select the type of goods
            </div>
          </div>
          <div class="form-group col-sm-8 col-lg-5">
            <label v-if="index === 0">Description</label>
            <input
              type="text"
              class="form-control"
              placeholder="Building materials"
              v-model="line.description"
              :class="{ 'is-invalid': errors.has('description-' + index) }"
              :name="'description-' + index"
              v-validate="'required'"
              @keyup="line.other_desc.additional = $event.target.value"
            />
            <div
              v-show="errors.has('description-' + index)"
              class="invalid-feedback"
            >
              Please enter a description
            </div>
          </div>
          <div class="form-group col-sm-6 col-lg-3">
            <label v-if="index === 0">Total Weight</label>
            <div class="input-group">
              <input
                placeholder="500"
                type="text"
                class="form-control"
                v-model="line.weight"
                :class="{
                  'is-invalid':
                    errors.has('weight-' + index) ||
                    errors.has('weight_by_number-' + index)
                }"
                :name="'weight-' + index"
                v-validate="'required|min_value:0.1'"
                v-on:blur="computedAll($event, index)"
                @click="
                  descriptionValidation(
                    line.packageType,
                    line.other_desc.additional,
                    packageTypes,
                    index
                  )
                "
                @keyup="
                  descriptionValidation(
                    line.packageType,
                    line.other_desc.additional,
                    packageTypes,
                    index
                  )
                "
              />
              <div class="input-group-append">
                <span class="input-group-text">kg</span>
              </div>
              <div
                v-show="errors.has('weight-' + index)"
                class="invalid-feedback"
              >
                Please enter a numeric weight
              </div>
              <div
                v-show="errors.has('weight_by_number-' + index)"
                class="invalid-feedback"
              >
                {{ errors.first("weight_by_number-" + index) }}
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  v-tooltip.hover.focus="
                    'Please double-check or call our team on (09) 280 3639'
                  "
                ></i>
              </div>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="line.weight_by_number"
              :name="'weight_by_number-' + index"
              v-validate="isOverWeight(index)"
              style="display: none"
            />
          </div>
          <div class="form-group col-sm-6 col-lg-3">
            <label v-if="index === 0">Total Volume</label>
            <div class="input-group">
              <!--              <input
                placeholder="3"
                type="text"
                class="form-control"
                v-model="line.volume"
                :class="{
                  'is-invalid':
                    errors.has('volume-' + index) ||
                    errors.has('volume_by_number-' + index),
                }"
                :name="'volume-' + index"
                v-validate="'required|min_value:0.01'"
                @click="openModalDimension(index)"
                v-on:blur="computedAll($event, index)"
              />-->
              <input
                placeholder="3"
                type="text"
                class="form-control"
                v-model="line.volume"
                :class="{
                  'is-invalid':
                    errors.has('volume-' + index) ||
                    errors.has('volume_by_number-' + index)
                }"
                :name="'volume-' + index"
                v-validate="'required|min_value:0.01'"
                v-on:blur="computedAll($event, index)"
                @click="onClickVolume(line.packageType, index, packageTypes)"
              />
              <div
                class="input-group-append"
                v-tooltip:top="
                  'The volume in metres cubed is equal to: width x length x height'
                "
              >
                <span class="input-group-text">m<sup>3</sup></span>
              </div>
              <div
                v-show="errors.has('volume-' + index)"
                class="invalid-feedback"
              >
                Please enter a numeric volume
              </div>
              <div
                v-show="errors.has('volume_by_number-' + index)"
                class="invalid-feedback"
              >
                {{ errors.first("volume_by_number-" + index) }}
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  v-tooltip.hover.focus="
                    'Please double-check or call our team on (09) 280 3639.'
                  "
                ></i>
              </div>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="line.volume_by_number"
              :name="'volume_by_number-' + index"
              v-validate="isOverSize(index)"
              style="display: none"
            />
          </div>
          <a
            href="#"
            class="freight-row-delete"
            @click.prevent="$emit('removeFreightLine', index)"
            v-if="freight.length > 1"
            style="right: -0.9rem !important"
          >
            <i class="far fa-minus-circle"></i>
            <span class="hidden-lg-up">Remove row</span>
          </a>

          <hr class="mt-2 mb-4 hidden-lg-up" />
        </div>

        <dangerous-goods
          @addLine="addDangerousGoodLine(line)"
          v-if="line.dangerousGoods.length > 0"
          :dangerousGoods="dangerousGoods"
          :lines="line.dangerousGoods"
          :freightIndex="index"
        ></dangerous-goods>
      </div>

      <div class="text-center">
        <button
          class="btn btn-link"
          type="button"
          @click="$emit('addFreightLine')"
          style="font-size: 14px; font-weight: bold"
        >
          <i class="far fa-plus-circle"></i> Add another row
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import DangerousGoods from "./DangerousGoods";

export default {
  name: "freight",
  components: { DangerousGoods },
  props: ["hasChepAccess", "freight", "packageTypes", "delivery"],
  inject: ["$validator"],

  data() {
    return {
      goodTypes: null,
      dangerousGoods: null,
      addOrDelete: false,
      showDimensionModal: false,
      isEditVolume: false,
      volumeIndex: null,
      dimension: {
        width: 0,
        height: 0,
        length: 0
      },
      previousTotalVolume: 0,
      typeDim: {
        width: 0,
        height: 0,
        length: 0
      }
    };
  },

  mounted() {
    this.loadInitialData();
    Event.$on("loadDangerousGoods", this.loadDangerousGoods);
  },

  methods: {
    loadInitialData() {
      this.loadGoodTypes();
      this.loadDangerousGoods();
    },

    loadGoodTypes() {
      axios
        .get("/api/goods-types")
        .then(response => {
          this.goodTypes = response.data.data;
        })
        .catch(error => {
          Event.$emit("serverError");
        });
    },

    loadDangerousGoods() {
      this.dangerousGoods = null;

      axios
        .get("/send-freight/dangerous-goods", {
          headers: { Accept: "application/json" }
        })
        .then(response => {
          this.dangerousGoods = response.data.data;

          let that = this;
          this.dangerousGoods.map(function(dangerousGood) {
            that.freight.map(function(line, lineIndex) {
              if (!line.dangerousGoods || !line.dangerousGoods.length) {
                return true;
              }

              line.dangerousGoods.map(function(dgLine, dgLineIndex) {
                if (dgLine.product && dgLine.product.id == dangerousGood.id) {
                  that.freight[lineIndex].dangerousGoods[
                    dgLineIndex
                  ].product = dangerousGood;
                }
              });
            });
          });
        })
        .catch(error => {
          Event.$emit("serverError");
        });
    },

    checkIfDangerous(freight) {
      if (freight.goodsType === 11) {
        this.addDangerousGoodLine(freight);
      } else {
        freight.dangerousGoods = [];
      }
    },

    addDangerousGoodLine(line) {
      line.dangerousGoods.push({
        amount: null,
        quantity: 1,
        unit: "Kg",
        product: null
      });
    },

    descriptionValidation(
      package_type_id,
      additional_desc,
      packageTypes,
      index
    ) {
      let package_type = packageTypes.filter(function(packageType) {
        return packageType.id == package_type_id;
      });

      if (package_type[0].id == 24 || package_type[0].id == 4) {
        if (!additional_desc) {
          this.$swal({
            title: `Please add in the description of your ${
              package_type[0].id === 24
                ? "Oversize pallet(s)"
                : package_type[0].name
            }`,
            type: "warning"
          });
          this.freight[index].weight = null;
        }
      }

      let maxWeight = 500 * parseInt(this.freight[index].quantity);

      if (package_type_id !== 15 && package_type_id !== 18) {
        if (!this.delivery.location.has_forklift) {
          if (this.freight[index].weight > maxWeight) {
            this.$swal({
              title: `Due to tail lift weight restrictions each pallet needs to be ${maxWeight.toLocaleString()} kgs or less`,
              type: "warning"
            });
            this.freight[index].weight = null;
          }
        }
      }
    },

    onClickVolume(package_type_id, index, packageTypes) {
      this.isEditVolume = true;

      var package_type = packageTypes.filter(function(packageType) {
        return packageType.id == package_type_id;
      });

      if (package_type[0].id == 24 || package_type[0].id == 4) {
        this.openModalDimension(index);
      }

      this.freight[index].max_weight = package_type[0].max_weight
        ? parseFloat(package_type[0].max_weight)
        : null;
      this.freight[index].max_volume = package_type[0].max_volume
        ? parseFloat(package_type[0].max_volume)
        : null;
    },

    onChangeType(event, index, packageTypes, description) {
      var package_type = packageTypes.filter(function(packageType) {
        return packageType.id == event.target.value;
      });

      if (package_type[0].id == 24 || package_type[0].id == 4)
        this.openModalDimension(index);

      this.freight[index].max_weight = package_type[0].max_weight
        ? parseFloat(package_type[0].max_weight)
        : null;
      this.freight[index].max_volume = package_type[0].max_volume
        ? parseFloat(package_type[0].max_volume)
        : null;

      this.freight[index].description = description;
      this.freight[index].volume = null;
      this.freight[index].weight = null;
      this.freight[index].other_desc.additional = null;
    },

    isOverWeight(index) {
      if (!this.freight[index].max_weight) {
        return false;
      }

      if (this.freight[index].max_weight !== null) {
        if (
          this.freight[index].weight >
          this.freight[index].max_weight * this.freight[index].quantity
        ) {
          if (
            typeof this.errors.first("weight_by_number-" + index) ===
            "undefined"
          ) {
            this.errors.add({
              field: "weight_by_number-" + index,
              msg:
                "The weight entered exceeds the maximum for this package type."
            });
          }

          return false;
        }

        this.errors.remove("weight_by_number-" + index);

        return true;
      }

      this.errors.remove("weight_by_number-" + index);

      return true;
    },

    isOverSize(index) {
      if (!this.freight[index].max_volume) {
        return false;
      }

      if (this.freight[index].max_volume !== null) {
        if (
          this.freight[index].volume >
          this.freight[index].max_volume * this.freight[index].quantity
        ) {
          if (
            typeof this.errors.first("volume_by_number-" + index) ===
            "undefined"
          ) {
            this.errors.add({
              field: "volume_by_number-" + index,
              msg:
                "The volume entered exceeds the maximum for this package type."
            });
          }

          return false;
        }

        this.errors.remove("volume_by_number-" + index);

        return true;
      }

      this.errors.remove("volume_by_number-" + index);

      return true;
    },

    computedAll(event, index, isQtyChanged = false) {
      var qty, weight, volume;

      qty = parseInt(this.freight[index].quantity);
      weight =
        this.freight[index].weight != ""
          ? parseFloat(this.freight[index].weight)
          : 0;
      volume =
        this.freight[index].volume != ""
          ? parseFloat(this.freight[index].volume)
          : 0;

      this.freight[index].weight_by_number = parseInt(qty) * weight;
      this.freight[index].volume_by_number = parseInt(qty) * volume;

      let packageType = this.freight[index].packageType;

      //reset volume if qty changed for oversize pallets & large loose items
      if (isQtyChanged) {
        if (packageType === 24 || packageType === 4) {
          let totalVolume = (qty * this.previousTotalVolume).toFixed(2);
          this.freight[index].volume = totalVolume;
        } else {
          this.freight[index].weight = null;
        }
      }

      this.isOverWeight(index);
      this.isOverSize(index);
    },

    openModalDimension(index) {
      this.volumeIndex = index;
      this.$vfm.show("dimension-modal");
    },

    setVolume() {
      let volume =
        parseFloat(this.dimension.width) *
        parseFloat(this.dimension.height) *
        parseFloat(this.dimension.length);

      //save last value of total volume
      this.previousTotalVolume = volume;

      let volumeDimension =
        " [" +
        this.dimension.length +
        "l X " +
        this.dimension.width +
        "w X " +
        this.dimension.height +
        "h] ";

      let desc = this.freight[this.volumeIndex].description;
      let updatedDesc;

      if (desc) {
        //regex to get volume dimension
        let getVolumeDimension = desc.match(/\[(.*?)\]/g);
        updatedDesc = getVolumeDimension
          ? desc.replace(/ *\[[^)]*\] */g, volumeDimension)
          : desc + volumeDimension;
      } else {
        updatedDesc = desc + volumeDimension;
      }

      this.freight[this.volumeIndex].description = updatedDesc;
      this.freight[this.volumeIndex].volume = (
        volume * parseInt(this.freight[this.volumeIndex].quantity)
      ).toFixed(2);

      this.volumeIndex = null;
      this.dimension = {
        width: 0,
        height: 0,
        length: 0
      };

      this.$vfm.hide("dimension-modal");
    },

    closeModalDimension() {
      this.volumeIndex = null;
      this.dimension = {
        width: 0,
        height: 0,
        length: 0
      };

      this.$vfm.hide("dimension-modal");
    }
  },

  computed: {
    loading() {
      return (
        this.packageTypes.length == 0 || !this.goodTypes || !this.dangerousGoods
      );
    }
  },

  watch: {
    freight(newVal, oldVal) {
      if (this.freight.goodsType === 11) {
         this.freight.dangerousGoods.push({
            amount: newVal[0].amount,
            quantity: newVal[0].quantity,
            unit: newVal[0].unit,
            product: newVal[0].product
          });
      } else {
        this.freight.dangerousGoods = [];
      }
    }
  }
};
</script>
